import React from "react";
import { motion } from "framer-motion";

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1],
      delay: i * 0.12,
    },
  }),
};

const Line = ({ children, i }) => (
  <span className="block overflow-hidden">
    <motion.span
      className="inline-block will-change-transform"
      variants={lineVariants}
      custom={i}
    >
      {children}
    </motion.span>
  </span>
);

const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative px-6 md:px-12 lg:px-20 py-20 md:py-28"
    >
      <div className="max-w-6xl">
        <div className="flex items-center gap-4 mb-8">
          <span className="h-px w-12 bg-[#0a0a0b]/30" />
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">01 — Manifesto</span>
        </div>
        <motion.h2
          data-testid="manifesto-headline"
          className="font-display font-medium tracking-tight leading-[1.05] text-[#0a0a0b]"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
        >
          <Line i={0}>
            <span style={{ fontSize: "clamp(2rem, 5vw, 4.5rem)" }}>
              Every business is buried in noise.
            </span>
          </Line>
          <Line i={1}>
            <span style={{ fontSize: "clamp(2rem, 5vw, 4.5rem)" }}>
              We dig through it, <span className="accent-text">design the path,</span>
            </span>
          </Line>
          <Line i={2}>
            <span style={{ fontSize: "clamp(2rem, 5vw, 4.5rem)" }}>
              and automate the climb.
            </span>
          </Line>
        </motion.h2>
        <p className="mt-10 max-w-xl text-base md:text-lg text-muted-ink" data-testid="manifesto-body">
          Strategy, build, and intelligence under one roof.
        </p>
      </div>
    </section>
  );
};

export default Manifesto;
